import { Box, Center, Flex, Image } from "@chakra-ui/react";
import React from "react";
import CustomText from "./CustomText";
import musk from "../assets/images/musk.svg";
import followText from "../assets/images/follow_text.svg";
import twitter from "../assets/images/simple-icons_x.svg";
import discord from "../assets/images/ic_baseline-discord.svg";
import telegram from "../assets/images/cib_telegram.svg";

const FollowUs = () => {
  return (
    <section id="follow-us">
      <Center
        flexDirection="column"
        pb={"90px"}
        display={{ base: "flex", lg: "none" }}
      >
        <Image
          src={followText}
          alt="follow text"
          // position={"absolute"}
          // bottom={500}
          // left={430}
          mr={"-120px"}
          mt={"-30px"}
          w={"40%"}
        />
        <Image
          src={musk}
          alt="musk"
          mt={"-30px"}
          // position={"absolute"}
          // bottom={0}
          // left={0}
          w={"60%"}
        />
        <Flex gap={"12px"} ml={"-20px"}>
          <Image src={twitter} alt="twitter x" w={"40px"} />
          <Image src={discord} alt="discord" w={"40px"} />
          <Image src={telegram} alt="telegram" w={"40px"} />
        </Flex>
        <Flex
          w={"100%"}
          textAlign={"center"}
          mt={"10px"}
          flexDir="column"
          px="20px"
        >
          <CustomText
            text="RELAX: Follow us on social if you dare — no heart problems required — ."
            size="22px"
            height="26.97px"
            color="#191919"
            align="center"
          />
          <CustomText
            text="Dive into the chaos with Furry Silence"
            size="22px"
            height="26.97px"
            color="#191919"
            align="center"
          />
        </Flex>
      </Center>
      <Box
        mt={"-90px"}
        py={"250px"}
        position={"relative"}
        display={{ base: "none", lg: "block" }}
      >
        <Box mt={"140px"}></Box>
        <Image
          src={followText}
          alt="follow text"
          position={"absolute"}
          bottom={520}
          left={"31%"}
          // w={"55%"}
        />
        <Image
          src={musk}
          alt="musk"
          position={"absolute"}
          bottom={0}
          left={0}
          w={"60%"}
        />

        <Flex justify={"end"} w={"100%"} maxW={"1250px"} mx="auto">
          <Box maxW={"720px"}>
            <CustomText
              text="RELAX: Follow us on social if you dare — no heart problems required — ."
              size="36px"
              height="40.97px"
              color="#191919"
              align="center"
            />
            <CustomText
              text="Dive into the chaos with Furry Silence"
              size="36px"
              height="40.97px"
              color="#191919"
              align="center"
            />
          </Box>
        </Flex>
        <Flex
          justify={"end"}
          maxW={"1250px"}
          gap={"30px"}
          mt={"130px"}
          mb={"-120px"}
          mx="auto"
        >
          <Image src={twitter} alt="twitter x" />
          <Image src={discord} alt="discord" />
          <Image src={telegram} alt="telegram" />
        </Flex>
      </Box>
    </section>
  );
};

export default FollowUs;
